import AuthController from '../services/AuthController.js';
import { getSuspendedEditor, discardSuspendedEditor, parseEditorPath } from './magnetEditorSession.js';

// Runs before mounting any creator/editor, so another editor cannot replace the
// shared flow models while an unfinished working copy is held out of the DOM.
export function showEditorRecovery(container, path, retry) {
  const held = getSuspendedEditor();
  if (!held) return false;
  const sameAccount = held.actor === AuthController.getEntity()?.guid;
  const sameTarget = held.guid === (parseEditorPath(path)?.guid || (path === '/magnets/new' ? 'new' : null));
  if (sameAccount && sameTarget && held.org === AuthController.getStoredActiveOrg() && held.resumeRequested) return false;
  const panel = document.createElement('section'); panel.className = 'page-shell mag-create';
  const heading = document.createElement('h1'); heading.textContent = 'Your unfinished work is still here';
  const message = document.createElement('p'); message.setAttribute('role', 'status');
  message.textContent = sameAccount
    ? 'Resume in the original workspace. We’ll check your access and the saved version first. Keep this tab open; these edits have not been saved.'
    : 'Sign in with the account you were using to recover this work. Keep this tab open; these edits have not been saved.';
  panel.append(heading, message);
  if (sameAccount) {
    const resume = document.createElement('button'); resume.type = 'button'; resume.textContent = 'Resume unfinished work';
    resume.className = 'btn btn-primary';
    resume.addEventListener('click', async () => {
      resume.disabled = true;
      try {
        await AuthController.setActiveOrg(held.org);
        if (getSuspendedEditor() !== held || held.actor !== AuthController.getEntity()?.guid) return;
        if (held.org !== AuthController.getStoredActiveOrg()) throw new Error('Workspace no longer available');
        held.resumeRequested = true;
        if (sameTarget) retry(); else window.router.navigate(held.path);
      } catch { message.textContent = 'We could not confirm your workspace. Your edits are still held in this tab. Try again.'; }
      finally { resume.disabled = false; }
    });
    panel.append(resume);
  } else {
    const signin = document.createElement('a'); signin.href = '#/signin'; signin.textContent = 'Sign in again'; panel.append(signin);
  }
  const discard = document.createElement('button'); discard.type = 'button'; discard.textContent = 'Discard unfinished work';
  discard.addEventListener('click', () => {
    if (!confirm('Discard your unfinished magnet changes?')) return;
    discardSuspendedEditor(); retry();
  });
  panel.append(discard); container.replaceChildren(panel); heading.tabIndex = -1; heading.focus();
  return true;
}
